<template>
<div>
  <div class="container-fluid bg-login">
      <div class="container">

      </div>
  </div>
  <div class="container-fluid">
    <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6  card1 mart ">
            <div class="logo-bg">
              <img src="../assets/images/rmc-logo.png" class="img-fluid" alt="">
            </div>
            <h2 class="red"> Login</h2>
            <ValidationObserver  ref="observer" v-slot="{ invalid }"  @submit.prevent="submitpage()">
            <form class="mar-t-30">
              <div class="form-group">
                <span class="loginerror">{{errorreport}}</span>
                <span class="loginerror" v-show ="errormessage">{{error}}</span>
                </div>
              <div class="form-group">
                <ValidationProvider rules="required" name="Email" v-slot="{ errors }">
                  <input type="text" class="form-control logininput" placeholder="Email" v-model="login.email" v-on:keyup="errormessage = false" v-validate="'required'">
                  <!-- <input type="text" class="form-control logininput" placeholder="User ID" v-model="form.userid" v-on:blur="checkuserid(form.userid)"> -->
                  <!-- <span >Please enter User ID</span> -->
                  <span class="loginerror">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider rules="required" name="Password" v-slot="{ errors }">
                  <input type="password" class="form-control logininput" v-model="login.password" placeholder="Password" v-validate="'required'">
                  <!-- <span class="loginerror">Please enter Password</span> -->
                  <span class="loginerror">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="mar-t-30 text-center">
                <button type="submit" class="submit-button">Login</button>
              </div>

            </form>
            </ValidationObserver>
          </div>
        </div>
    </div>
  </div>

</div>

</template>
<script>
import {
  ValidationProvider,
  ValidationObserver
} from "vee-validate"
import {
  mapActions, mapGetters
} from 'vuex'
  export default {
    name: 'Login',
    data () {
      return {
        login: {
          email: '',
          password: ''
        },
        error: false,
        errormessage: '',
        errorreport: ''
      }
    },
    computed: {
      ...mapGetters(['getToken', 'getUser'])
    },
    created () {
      this.checktoken()
    },
    methods: {
      ...mapActions([
        'setToken',
        'setUser'
      ]),
      checktoken () {
              if (this.getToken !== null && this.getToken !== '' && this.getToken !== undefined) {

              this.$router.push('/dashboard')


        }
      },
      async submitpage () {
        this.vueloaders = true
        const isValid = await this.$refs.observer.validate()
    if (isValid) {
      this.errorreport = ''
        this.$http.post('/auth/authentication', this.login).then((res) => {
          if (res.data.success === true) {
            this.setToken(res.data.token)
            this.error = ''
            this.errormessage = false,
            localStorage.setItem('token', res.data.token)
            this.setUser(res.data.details[0])
            localStorage.setItem('userdetails', JSON.stringify(res.data.details[0]))
            console.log(res.data.details)
            this.$router.push('/dashboard')
          } else {
            this.error = 'Please Check Email and Password'
            this.errormessage = true
          }
        }).catch((err) => {
          this.vueloaders = false
          this.$toasted.success('Server Not availble.Try Again', {
              position: 'top-right',
              duration: 3000,
              theme: 'outline'
            })
          console.log(err)
        })
    } else {
      this.errormessage = true
      this.error = "All Feilds Are Required."
    }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login.vue